import { defineStore } from 'pinia';
import { ref } from 'vue';
import UsersApiService from '@/api/UsersApiService';

export const useUserStore = defineStore('user', () => {
  const isAdmin = ref(false);
  const isLoaded = ref(false);

  async function checkAdminStatus(): Promise<void> {
    if (isLoaded.value) return;

    try {
      const response = await UsersApiService.isAdmin();
      isAdmin.value = response.data.result;
    } catch {
      isAdmin.value = false;
    }
    isLoaded.value = true;
  }

  return {
    isAdmin,
    isLoaded,
    checkAdminStatus
  };
});
